export default function applyCountdown({
  selector,
  template,
  onFinish = () => {}
}) {
  vendorManager.ensure('jquery.countdown', () => {
    const countdown = $(selector);

    if (countdown && countdown.length > 0) {
      if (countdown.length === 1) {
        const finalDate = countdown.data('value');

        countdown
          .countdown(finalDate)
          .on('update.countdown', function (event) {
            $(this).html(event.strftime(template));
          })
          .on('finish.countdown', onFinish);
      } else {
        countdown.each(function (_, el) {
          const countdownEl = $(el);
          const finalDate = countdownEl.data('value');

          countdownEl
            .countdown(finalDate)
            .on('update.countdown', function (event) {
              $(this).html(event.strftime(template));
            })
            .on('finish.countdown', onFinish);
        });
      }
    }
  });
}
